// import { AgainstAdvance } from './EnterTransactionsAPI';
import {error} from 'console'
import {Transaction} from './ViewTransactionsAPI'
import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

export interface AccountingDetails {
  byLedger: ByLedger
  toLedger: ToLedger
  voucherTypeMap: VoucherTypeMap
  voucherCurrency: string[]
  ledgerCurrentBalanceMapping: Record<string, Record<string, string>>
  reportingCurrency: string
  ledgerMapping: any
  voucherMapping: any
  voucherNumberMapping: any
}

export interface ByLedger {
  journal: Record<string, string[]>
  receipt: Record<string, string[]>
  payment: Record<string, string[]>
  contra: Record<string, string[]>
  sales: Record<string, string[]>
  purchases: Record<string, string[]>
  debitnote: Record<string, string[]>
  creditnote: Record<string, string[]>
}

export interface ToLedger {
  journal: Record<string, string[]>
  receipt: Record<string, string[]>
  payment: Record<string, string[]>
  contra: Record<string, string[]>
  sales: Record<string, string[]>
  purchases: Record<string, string[]>
  debitnote: Record<string, string[]>
  creditnote: Record<string, string[]>
}

export interface VoucherTypeMap {
  journal: string[]
  receipt: string[]
  payment: string[]
  contra: string[]
  sales: string[]
  purchase: string[]
  debitnote: string[]
  creditnote: string[]
}

export const getAccountingDetails = async (
  companyId: string,
  fy: string
): Promise<AccountingDetails | undefined> => {
  return await axios
    .get(`${API_URL}/accounting/transaction/data/${companyId}/${fy}`)
    .then((response: AxiosResponse) => {
      const {
        by_ledger,
        to_ledger,
        voucher_map,
        transacting_currency,
        reporting_currency,
        ledger_current_balance,
        ledger_id,
        voucher_id,
        voucher_number,
      } = response.data

      return {
        byLedger: by_ledger,
        toLedger: to_ledger,
        voucherTypeMap: voucher_map,
        voucherCurrency: transacting_currency,
        reportingCurrency: reporting_currency,
        ledgerCurrentBalanceMapping: ledger_current_balance,
        ledgerMapping: ledger_id,
        voucherMapping: Object.fromEntries(
          Object.entries(voucher_id).map(([key, value]) => [
            key.split(' ').join('').toLowerCase(),
            value,
          ])
        ),
        voucherNumberMapping: Object.fromEntries(
          Object.entries(voucher_number).map(([key, value]) => [
            key.split(' ').join('').toLowerCase(),
            value,
          ])
        ),
      }
    })
}

export type IndividualTransaction = {
  transactionType: 'debit' | 'credit'
  parentLedger: string
  subLedger: string | null
  ledgerCode?: string | null
  amount: number
  transactionAmount?: number
}
export type TransactionItem = {
  transaction_item_id?: number
  transaction_id?: number
  transaction_type: 'debit' | 'credit'
  ledger_id?: number
  transaction_amount?: number
}

export interface CreateTransactionBody {
  transaction: CreateReferenceBody
  create_reference: CreateTransactionRefBody[]
  // To change
  // dbId?: number
  // companyId?: string
  // fyName?: string
  // voucherType?: string
  // voucherName?: string | null
  // voucherDate?: string
  // voucherCurrency?: string
  // reportingCurrency?: string
  // transactingCurrency?: string
  // transactionDetails?: IndividualTransaction[]
  // narration?: string
  // previousVoucherType?: string
  // fetchedRate?: number
  // applicableRate?: number
  // updateExchangeRate?: boolean
  // voucherNumber?: number
  // totalAmount?: number
  // invoiceNumber?: string
  // invoiceAmount?: number
  // invoiceDescription?: string
  // invoiceDetails?: SetOffInvoiceResp[]
  // exchangeMultiplier?: string
  // isNAReferenceAmount?: number
}
export interface CreateReferenceBody {
  transaction_id?: number
  company_id?: number
  fy_name?: string
  voucher_id?: number
  voucher_number?: number | null
  currency_code: string
  voucher_date?: string
  is_na_reference: boolean
  update_exchange_rate: boolean
  na_reference_amount: number
  reporting_currency?: string
  transaction_item?: TransactionItem[]
  narration?: string | null
  exchange_multiplier?: number
  total_amount?: number

  // invoiceDetails?: SetOffInvoiceResp[]

  // isNAReferenceAmount?: number
}

export type AgainstAdvance = {
  advanceId: number
  advanceNumber: number
  advanceDate: string
  amount: number
  transactionType: string
  settledAmount: number
  setOffAmount: number
  voucherType: string
  voucherNumber: number
  description: string
}

export type AgainstInvoice = {
  invoiceId: number
  invoiceNumber: number
  invoiceDate: string
  dueDate: string
  amount: number
  transactionType: string
  settledAmount: number
  setOffAmount: number
  voucherType: string
  voucherNumber: number
  description: string
}

export type AdvanceItem = {
  advanceNumber: string
  advanceDate: string
  amount: number
  transactionType: string
  description: string
}

export type InvoiceItem = {
  invoiceNumber: string
  invoiceDate: string
  dueDate: string
  amount: number
  transactionType: string
  description: string
}

export type messageBody = {
  type: string
  message: string
}
export interface CreateReferenceResp {
  // transactionDetails:[]
  showOptions: boolean
  transactionItemId: number
  transactionId: number
  ledgerId: number
  ledgerCode: string
  parentLedger: string
  subLedger: string
  transactionType: string
  transactionAmount: number
  invoiceNumber: number
  invoiceItem: InvoiceItem | null
  againstAdvance: AgainstAdvance[] | null
  advanceNumber: number
  againstInvoice: AgainstInvoice[] | null
  advanceItem: AdvanceItem | null
  isNaReference: boolean
  referenceAmount: number
  message: messageBody[]
}

export type InvoiceItemBody = {
  invoice_number: string
  invoice_date: string
  due_date: string
  amount: number
  transaction_type: string
  description: string
}

export type AgainstAdvanceBody = {
  advance_id: number
  advance_number: number
  advance_date: string
  amount: number
  transaction_type: string
  settled_amount: number
  set_off_amount: number
  voucher_type: string
  voucher_number: number
  description: string
}

export type AgainstInvoiceBody = {
  invoice_id: number
  invoice_number: number
  invoice_date: string
  due_date: string
  amount: number
  transaction_type: string
  settled_amount: number
  set_off_amount: number
  voucher_type: string
  voucher_number: number
  description: string
}

export type AdvanceItemBody = {
  advance_number: string
  advance_date: string
  amount: number
  transaction_type: string
  description: string
}

export interface CreateTransactionRefBody {
  show_options: boolean
  transaction_item_id: number
  transaction_id: number
  ledger_id: number
  ledger_code: string
  parent_ledger: string
  sub_ledger: string
  transaction_type: string
  transaction_amount: number
  invoice_number: number
  invoice_item: InvoiceItemBody | null
  against_advance: AgainstAdvanceBody[] | null
  advance_number: number
  against_invoice: AgainstInvoiceBody[] | null
  advance_item: AdvanceItemBody | null
  is_na_reference: boolean
  reference_amount: number
  message: messageBody[]
}

export const createTransaction = async (
  body: CreateTransactionBody
): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/accounting/transaction/add/transaction`, body, {
      validateStatus: () => true,
    })
    if (!response || !response.data) throw new Error('Some error occurred. Please try again.')
    if (response.data && response.data.status && response.data.status === 'error')
      throw new Error(response.data.message)
    if (response.data.detail && response.data.detail === 'Not Found') {
      console.log(response.data.detail)
      throw new Error(response.data.detail)
    }
    return response.data
  } catch (error: any) {
    if (error) throw error
  }
}

type ExchangeRateResp = {
  companyId: number
  currencyCode: string
  exchangeRate: number
  // exchangeDate: string
  asOnDate: string
  newExchangeRate?: string
}

export const getExchangeRate = async (
  companyId: string,
  fy: string,
  ref_date: string,
  currency_code: string
): Promise<ExchangeRateResp | undefined> => {
  return await axios
    .get(
      `${API_URL}/accounting/transaction/data/exchange-rate/${companyId}/${fy}?voucher_date=${ref_date}&currency_code=${currency_code}`
    )
    .then((response: AxiosResponse) => ({
      companyId: Number(companyId),
      currencyCode: response.data.currency_code,
      asOnDate: response.data.exchange_date,
      exchangeRate: response.data.exchange_rate,
      newExchangeRate: response.data.new_exchange_rate,
    }))
}

export interface SetOffInvoiceResp {
  invoiceNumber: string
  invoiceAmount: number
  settledInvoiceAmount: number
  setOffAmount: number
  voucherType: string
  voucherNumber: number
}

export const getSetOffInvoiceDetails = async (
  companyId: string,
  fy: string,
  parentLedger: string,
  voucher_date: string,
  subLedger?: string
): Promise<{invoiceDetails: SetOffInvoiceResp[]} | undefined> => {
  let url = `${API_URL}/accounting/transactions/invoice/details/${companyId}/${fy}?parent_ledger=${parentLedger}&voucher_date=${voucher_date}`
  if (subLedger) url += `&sub_ledger=${subLedger}`
  url = encodeURI(url)
  return await axios
    .get(url)
    .then((response: AxiosResponse<{invoiceDetails: SetOffInvoiceResp[]}>) => response.data)
    .then((response: {invoiceDetails: SetOffInvoiceResp[]}) => response)
}
export const createNewTransaction = async (
  body: CreateReferenceBody
): Promise<{transactionDetails: CreateReferenceResp[]} | undefined> => {
  try {
    const response = await axios.post(
      `${API_URL}/accounting/transaction/add/create-reference`,
      body,
      {
        validateStatus: () => true,
      }
    )
    if (!response || !response.data) throw new Error('Some error occurred. Please try again.')
    if (response.data && response.data.status && response.data.status === 'error')
      throw new Error(response.data.message)
    return response.data.map((_: any) => ({
      showOptions: _.show_options,
      transactionItemId: _.transaction_item_id,
      transactionId: _.transaction_id,
      ledgerId: _.ledger_id,
      ledgerCode: _.ledger_code,
      parentLedger: _.parent_ledger,
      subLedger: _.sub_ledger,
      transactionType: _.transaction_type,
      transactionAmount: _.transaction_amount,
      invoiceNumber: _.invoice_number,
      invoiceItem: _.invoice_item && {
        invoiceNumber: _.invoice_item.invoice_number,
        invoiceDate: _.invoice_item.invoice_date,
        dueDate: _.invoice_item.due_date,
        amount: _.invoice_item.amount,
        transactionType: _.invoice_item.transactionType,
        description: _.invoice_item.description,
      },
      againstAdvance:
        _.against_advance &&
        _.against_advance.map((tr: any) => ({
          advanceId: tr.advance_id,
          advanceNumber: tr.advance_number,
          advanceDate: tr.advance_date,
          amount: tr.amount,
          transactionType: tr.transaction_type,
          settledAmount: tr.settled_amount,
          setOffAmount: tr.set_off_amount,
          voucherType: tr.voucher_type,
          voucherNumber: tr.voucher_number,
          description: tr.description,
        })),
      advanceNumber: _.advance_number,
      advanceItem: _.advance_item && {
        advanceNumber: _.advance_item.advance_number,
        advanceDate: _.advance_item.advance_date,
        amount: _.advance_item.amount,
        transactionType: _.advance_item.transaction_type,
        description: _.advance_item.description,
      },
      againstInvoice:
        _.against_invoice &&
        _.against_invoice.map((inv: any) => ({
          invoiceId: inv.invoice_id,
          invoiceNumber: inv.invoice_number,
          invoiceDate: inv.invoice_date,
          dueDate: inv.due_date,
          amount: inv.amount,
          transactionType: inv.transaction_type,
          settledAmount: inv.settled_amount,
          setOffAmount: inv.set_off_amount,
          voucherType: inv.voucher_type,
          voucherNumber: inv.voucher_number,
          description: inv.description,
        })),
      isNaReference: _.is_na_reference,
      referenceAmount: _.reference_amount,
      message: _.message.filter((msg: any) => msg),
    }))
  } catch (error: any) {
    if (error) throw error
  }
}
